import { Component, Input } from '@angular/core';
import { Benefits } from 'src/app/home/models/benefts.interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-card-benefit',
  templateUrl: './card-benefit.component.html',
  styleUrls: ['./card-benefit.component.scss'],
})
export class CardBenefitComponent {
  @Input() benefit!: Benefits;
  user_plan!:any;

  arrStar = [1, 2, 3, 4, 5];

  constructor(
    private router: Router,
    private activatedRoute:ActivatedRoute
  ) {
    this.user_plan = this.activatedRoute.snapshot.data['resolve_user_plan'] ?? []; 
  }

  goToDetailBenefit() {
    this.router.navigate(['/benefits'], {
      queryParams: { idBenefit: this.benefit.id },
    });
  }

  averageStar() {
    if (this.benefit != null) {
      return this.benefit.average;
    } else {
      return 0;
    }
  }

  benefitIsPlan() { 
    if (this.benefit.plans.includes(this.user_plan.plan_id)) {
      return true;
    } else {
      return false;
    }
  }
}
